import React from "react";
import { ReactComponent as ArrowDownSvg } from "../images/arrow-down-icon.svg";

const ArrowDownIcon = (props) => {
  return <ArrowDownSvg {...props} />;
};

export default ArrowDownIcon;
